import {
  CreatorBreadcrumbsHeader,
  CampaignBreadcrumbsHeader,
  ListsBreadcrumbsHeader,
} from './breadcrumbs-header';
import Campaign from './campaign';
import CampaignOpenBriefButton from './campaign/CampaignOpenBriefButton';
import Campaigns from './campaigns';
import Generic from './generic';
import Stats from './stats';

function BrandHeaderChild() {}

BrandHeaderChild.CampaignBreadcrumbsHeader = CampaignBreadcrumbsHeader;
BrandHeaderChild.CreatorBreadcrumbsHeader = CreatorBreadcrumbsHeader;
BrandHeaderChild.ListsBreadcrumbsHeader = ListsBreadcrumbsHeader;
BrandHeaderChild.Campaign = Campaign;
BrandHeaderChild.CampaignOpenBriefButton = CampaignOpenBriefButton;
BrandHeaderChild.Campaigns = Campaigns;
BrandHeaderChild.Stats = Stats;
BrandHeaderChild.Generic = Generic;
export default BrandHeaderChild;
